module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "flexContainer fd-c full t-fd-r t-fw-nw",
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('section', {
    staticClass: "planosWrapper flexContainer jc-sb"
  }, [_c('section', {
    staticClass: "searchResultsWrapper size3of4 flexContainer fd-c"
  }, [_c('section', [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "btnExp iBlock pointer mobileNot txtCenter active fright uppercase",
    on: {
      "click": function($event) {
        _vm.showModal();
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("standDesign.create")) + "\n                            ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "resultsWrapper flexContainer fw-w",
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.standDesignList), function(standDesign) {
    return (standDesign.active !== false) ? _c('div', {
      key: standDesign.name,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [_c('span', {
      staticClass: "listTitle center"
    }, [_vm._v(_vm._s(standDesign.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [(standDesign.createdBy && standDesign.createdBy.firstname) ? _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(_vm.$t("planoList.created")) + " " + _vm._s(standDesign.createdBy.firstname) + "\n                                            " + _vm._s(standDesign.createdBy.lastname))]) : _vm._e(), _vm._v(" "), (standDesign.createdBy && standDesign.createdBy.firstname) ? _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(_vm.$t("planoList.modified")) + " " + _vm._s(standDesign.modifiedBy.firstname) + "\n                                            " + _vm._s(standDesign.modifiedBy.lastname))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [(standDesign.description !== null) ? _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(standDesign.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [_c('button', {
      staticClass: "btn editBtn abs center",
      on: {
        "click": function($event) {
          _vm.editStandDesign(standDesign);
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("editCampaign.edit")) + "\n                                        ")])])])])]) : _vm._e()
  }))], 1)])]), _vm._v(" "), (_vm.createStandDesign) ? _c('CreateStandDesign', {
    on: {
      "createStandDesign": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editStand) ? _c('EditStandDesign', {
    on: {
      "editStandDesign": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ec42a82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/standDesign/standList.vue
// module id = 3255
// module chunks = 0